import React, { useState, useEffect } from 'react';
import DynamicSections from '../../components/DynamicSections';
import TOC from '../../components/TOC';
import StickyCta from '../../components/StickyCta';
import CtaBanner from '../../components/CtaBanner';
import getAllReviews from '../../api/queries/reviews/getAllReviews';
import Popup from '../../components/Popup';
import createApolloClient from '../../api';

const Page = ({ data, headings, customReviewsData }) => {
  const [showPopup, setShowPopup] = useState(false);
  const pageData = data.pageBy;
  const noSideMenuTemplate = pageData.template.templateName === 'No Side Menu';
  const homepageTemplate = pageData.template.templateName === 'Homepage';
  const isContactPage = pageData.title === 'Get started';
  const { sections } = pageData.sections;
  const { title } = pageData;
  const { banner } = pageData.template;

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="page">
      {!homepageTemplate && <h1>{title}</h1>}
      {!noSideMenuTemplate && !isContactPage && !homepageTemplate && (
        <p>{banner.headingDescription}</p>
      )}
      {!noSideMenuTemplate && !isContactPage && !homepageTemplate && (
        <CtaBanner content={banner} customReviewsData={customReviewsData} />
      )}
      {!noSideMenuTemplate && !homepageTemplate && <TOC headings={headings} />}
      <DynamicSections
        hasSidebar={noSideMenuTemplate}
        isHomepage={homepageTemplate}
        sections={sections}
      />
      {!noSideMenuTemplate && !homepageTemplate && <StickyCta />}
      {!noSideMenuTemplate && !homepageTemplate && showPopup && (
        <Popup onClose={() => setShowPopup(false)} />
      )}
    </div>
  );
};

export default Page;

export async function getStaticProps() {
  const client = createApolloClient();
  const customReviewsData = await client.query(getAllReviews());
  return { props: { customReviewsData } };
}
